// Import Components
import Header from './components/Header';
import About from './components/About';
import Projects from './components/Projects';
import Experience from './components/Experience';
import Social from './components/Social';
import Footer from './components/Footer';
import Techstack from './components/Techstack';
import Resume from './components/Resume';

function App() {
	return (
		<div className="App">
			<Header />
			<About />
			<Projects />
			<Experience />
			<Techstack/>
			<Resume/>
			<Social />
			<Footer />
		</div>
	);
}

export default App;
